// extracted by mini-css-extract-plugin
export default {"sttContent":"STTSkeleton_sttContent__YeQ7u","usersInfoLine":"STTSkeleton_usersInfoLine__1N-ab"};